import { createFileRoute } from '@tanstack/react-router'
import { Layout } from '@/components/custom/layout'
import { useQuery } from '@tanstack/react-query'
import {
  reportSummaryTicket,
  reportSummaryTimeProcessTicket,
} from '@/api/report'
import { useState } from 'react'
import { format, subDays, addDays } from 'date-fns'
import { CardTicketTrend } from '@/components/reports-route/tickets/card-ticket-trend'
import { CardTimeProcess } from '@/components/reports-route/tickets/card-time-process'
import { CardTicketSession } from '@/components/reports-route/tickets/card-ticket-session'
import RangeDatePicker from '@/components/custom/range-date-picker'
import { navigateGuard } from '@/utils/auth.js'
import { UserRole } from '@/constants/user.js'
import { throwException } from '@/exceptions/throw-exception.js'
import QUERY_KEY from '@/constants/use-query-key.js'

export const Route = createFileRoute('/_auth/report/ticket')({
  beforeLoad: ({ location }) =>
    navigateGuard(location, [
      UserRole.ADMINISTRATOR,
      UserRole.SUPERVISOR,
      UserRole.TEAM_LEADER,
    ]),
  component: Ticket,
})

function Ticket() {
  const [rangeDate, setRangeDate] = useState({
    from_date: subDays(new Date(), 7),
    to_date: new Date(),
  })

  const fetchSummaryTicket = async () => {
    const payload = {
      from_date: format(subDays(rangeDate.from_date, 1), 'yyyy-MM-dd'), // Trừ 1 ngày
      to_date: format(addDays(rangeDate.to_date, 1), 'yyyy-MM-dd'), // Tăng 1 ngày
    }

    try {
      const resp = await reportSummaryTicket({ params: payload, data: payload })
      return resp.data
    } catch (error) {
      throwException(error)
      return []
    }
  }

  const fetchSummaryTimeProcessTicket = async () => {
    const payloadTimeProcessTicket = {
      date_from: format(rangeDate.from_date, 'yyyy-MM-dd'),
      date_to: format(addDays(rangeDate.to_date, 1), 'yyyy-MM-dd'), // Tăng 1 ngày
    }
    try {
      const resp = await reportSummaryTimeProcessTicket({
        params: {},
        data: payloadTimeProcessTicket,
      })
      return resp.data
    } catch (error) {
      throwException(error)
      return []
    }
  }

  const {
    isLoading: isLoadingSummaryTimeProcess,
    data: queryDataSummaryTimeProcess,
  } = useQuery({
    queryKey: [
      QUERY_KEY.GET_SUMMARY_TIME_PROCESS_TICKET_REPORT,
      { params: rangeDate, body: {} },
    ],
    queryFn: fetchSummaryTimeProcessTicket,
  })

  const { isLoading: isLoadingSummaryTicket, data: queryDataSummaryTicket } =
    useQuery({
      queryKey: [
        QUERY_KEY.GET_SUMMARY_TICKET_REPORT,
        { params: rangeDate, body: {} },
      ],
      queryFn: fetchSummaryTicket,
    })

  return (
    <Layout.Body>
      <div className="mb-4 flex items-center justify-between">
        <h1 className="text-lg font-bold">Báo cáo ticket</h1>
        <RangeDatePicker
          rangeDate={{
            from: rangeDate.from_date,
            to: rangeDate.to_date,
          }}
          onChangeRangeDate={(value) => {
            setRangeDate({
              from_date: value.from,
              to_date: value.to,
            })
          }}
        />
      </div>
      <div className="grid grid-cols-1 gap-4 xl:grid-cols-1">
        <div className="col-span-1 h-full gap-4">
          <div className="col-span-1 grid h-full gap-4">
            <CardTicketTrend
              isLoadingSummaryTicket={isLoadingSummaryTicket}
              queryDataSummaryTicket={queryDataSummaryTicket}
              params={rangeDate}
            />
          </div>
        </div>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-4 xl:grid-cols-1">
        <div className="col-span-1 h-full gap-4">
          <div className="col-span-1 grid h-full gap-8">
            <CardTimeProcess
              isLoadingSummaryTimeProcess={isLoadingSummaryTimeProcess}
              queryDataSummaryTimeProcess={queryDataSummaryTimeProcess}
              params={rangeDate}
            />
          </div>
        </div>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-4 xl:grid-cols-1">
        <div className="col-span-1 h-full gap-4">
          <div className="col-span-1 grid h-full gap-8">
            <CardTicketSession
              isLoadingSummaryTicket={isLoadingSummaryTicket}
              queryDataSummaryTicket={queryDataSummaryTicket}
              params={rangeDate}
            />
          </div>
        </div>
      </div>
    </Layout.Body>
  )
}
